import Printd from "printd";

export abstract class PrintWindow {
    protected finalizarImpresion(res: any) {
        const d = new Printd()
        const myElement: HTMLElement = document.getElementById('myElement')!;
        myElement.innerHTML = res;
        d.print(myElement);
    }
}